import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkAltOutline } from '@bonusly/design-system';

import { useActionInput } from '../../context';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

interface LinkButtonProps {
	decorationVariant?: 'default' | 'list-item';
}

export const LinkButton: FC<LinkButtonProps> = ({ decorationVariant = 'default' }) => {
	const isEnabled = useIsEnabled('link');
	const { editor } = useActionInput();
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	const handleClick = () => {
		if (editor) {
			editor.commands.insertLink();
		}
	};

	return (
		<DecorationButton label={t('decorations.add_a_link_tooltip')} onClick={handleClick} decorationVariant={decorationVariant}>
			<LinkAltOutline />
		</DecorationButton>
	);
};
